import { NavLink, Outlet, Navigate } from "react-router-dom";
import { useAuth } from "@/store/auth";
import NotificationBell from "@/components/NotificationBell";
import { Loader2, LayoutDashboard, ListChecks, CheckSquare, Brain, UserCircle } from "lucide-react";

const TABS = [
  { to: "/m",       icon: LayoutDashboard, label: "Home",  exact: true },
  { to: "/m/tasks", icon: ListChecks,      label: "Tasks"  },
  { to: "/m/inbox", icon: CheckSquare,     label: "Inbox"  },
  { to: "/m/ai",    icon: Brain,           label: "AI"     },
  { to: "/m/me",    icon: UserCircle,      label: "Me"     },
];

export default function MobileLayout() {
  const { user, loading } = useAuth();

  if (loading) return (
    <div className="h-screen flex items-center justify-center bg-slate-50">
      <Loader2 className="animate-spin text-[#334E7B]" size={28} />
    </div>
  );
  if (!user) return <Navigate to="/login" replace />;

  return (
    <div className="flex flex-col h-screen bg-slate-50 overflow-hidden">
      {/* Top header */}
      <header
        className="flex-shrink-0 h-14 bg-white/90 backdrop-blur-md border-b border-slate-200 flex items-center justify-between px-4 z-30"
        style={{ paddingTop: "env(safe-area-inset-top)" }}
        data-testid="mobile-header"
      >
        <div className="flex items-center gap-2.5 min-w-0">
          <img
            src="https://skiverse.skicorp.in/upload/process/79871716008647color_logo_without_tagline.png"
            alt="Skiverse"
            className="h-7 w-auto object-contain flex-shrink-0"
          />
          <div className="w-px h-7 bg-slate-300 flex-shrink-0" />
          <div className="flex flex-col text-[8.5px] font-bold uppercase tracking-widest text-slate-500 leading-[1.35]">
            <span>Task</span>
            <span>Management</span>
            <span>System</span>
          </div>
        </div>
        <div className="flex items-center gap-2">
          <NotificationBell />
          <div className="w-7 h-7 rounded-full bg-[#334E7B] flex items-center justify-center text-white text-xs font-bold flex-shrink-0">
            {user.name?.[0]?.toUpperCase() || "U"}
          </div>
        </div>
      </header>

      {/* Page content */}
      <main
        className="flex-1 overflow-y-auto overscroll-y-contain"
        style={{ paddingBottom: "calc(64px + env(safe-area-inset-bottom))" }}
      >
        <Outlet />
      </main>

      {/* Bottom tab bar */}
      <nav
        className="fixed bottom-0 left-0 right-0 bg-white border-t border-slate-200 z-30 flex"
        style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
        data-testid="mobile-nav"
      >
        {TABS.map(({ to, icon: Icon, label, exact }) => (
          <NavLink
            key={to}
            to={to}
            end={exact}
            className={({ isActive }) =>
              `flex-1 flex flex-col items-center justify-center py-2 gap-0.5 text-[10px] font-semibold transition-colors ${
                isActive ? "text-[#334E7B]" : "text-slate-400"
              }`
            }
          >
            {({ isActive }) => (
              <>
                <Icon size={22} strokeWidth={isActive ? 2.2 : 1.8} />
                <span>{label}</span>
              </>
            )}
          </NavLink>
        ))}
      </nav>
    </div>
  );
}
